<div class="map-container {{layout}}-map-container">
  <div class="map-frame {{layout}}-map-frame">
    <div class="geospatial-map" style="height:100%"></div>
  </div>
</div>

